import Config from 'react-native-config';
import perf from '@react-native-firebase/perf';
import {invoke, replace} from 'lodash';

import {log} from '/util/logger.util';

export class FirebasePerfMonitorBackend {
  perf: any;

  verbose: any;

  constructor({verbose}: any = {}) {
    this.verbose = verbose;
    this.perf = perf;
  }

  getMethod = (instance: any, {url, method}: any = {}) => {
    const endPoint = replace(url, Config.API_URL, '');

    return (methodName: any) => {
      return (...args: any[]) => {
        if (this.verbose) {
          log(
            `[FirebasePerfMonitor] "${methodName}" ${method} "${endPoint}".`,
            args,
          );
        }

        return invoke(instance, methodName, ...args);
      };
    };
  };

  getHttpMetric = async ({url, method, payloadSize}: any) => {
    const metric = await this.perf().newHttpMetric(url, method);

    if (payloadSize) {
      metric.setRequestPayloadSize(payloadSize);
    }

    const getHandler = this.getMethod(metric, {url, method});

    return {
      start: getHandler('start'),
      stop: getHandler('stop'),
      setResponseStatus: getHandler('setHttpResponseCode'),
      setResponseSize: getHandler('setResponsePayloadSize'),
      setCustomAttribute: getHandler('putAttribute'),
    };
  };

  setPerformanceCollectionEnabled = (status: any) => {
    this.perf().setPerformanceCollectionEnabled(status);
    if (this.verbose) {
      log(
        `[FirebasePerfMonitor] setPerformanceCollectionEnabled to "${status}".`,
      );
    }
  };
}
